<template>
  <el-dialog
    :visible.sync="importRoleActive"
    width="80%"
    @close="close"
    :close-on-click-modal="false"
  >
    <div class="dialogBox">
      <!-- {{selectDataList}} -->
      <el-row>
        <div>
          <el-col :span="10" class="leftTable">
            <div class="leftTitle">角色名称</div>
            <!--<el-input v-model="searchValue" placeholder="请输入" class="input-with-select" size="mini" suffix-icon="el-icon-search" style="margin: 10px 0;" />-->
            <div style="height: 205px">
              <el-table
                ref="selection"
                max-height="288"
                :data="leftTableData"
                size="mini"
                :show-header="showHeader"
                style="width: 100%"
                :header-cell-style="tableHeaderColor"
                @selection-change="checkAll"
              >
                <el-table-column type="selection" width="50" />
                <el-table-column prop="code" label="角色编号" />
                <el-table-column prop="name" label="角色名称" />
              </el-table>
            </div>
          </el-col>
          <el-col :span="4" class="btnMove">
            <div>
              <div class="opSetting" @click="handelSelect">
                <el-button
                  icon="el-icon-d-arrow-right"
                  :disabled="nowSelectData.length ? false : true"
                  size="mini"
                  type="primary"
                />
              </div>
              <div class="spacing" @click="handleRemoveSelect">
                <el-button
                  icon="el-icon-d-arrow-left"
                  :disabled="nowSelectRightData.length ? false : true"
                  size="mini"
                  type="primary"
                />
              </div>
            </div>
          </el-col>
          <el-col :span="10" class="leftTable">
            <div style="background-color: #fff; height: 290px">
              <el-table
                max-height="290"
                ref="selection"
                :data="rightTableData"
                size="mini"
                :header-cell-style="tableHeaderColor"
                @selection-change="checkRightAll"
              >
                <el-table-column type="selection" width="50" />
                <el-table-column prop="code" label="角色编号" width="100" />
                <el-table-column prop="name" label="角色名称" width="120" />
                <el-table-column prop="role" label="权限">
                  <template slot-scope="scope">
                    <el-cascader
                      size="mini"
                      v-model="selectDataList[scope.row.name]"
                      :options="roleData"
                      :props="props"
                      collapse-tags
                      clearable
                      style="width: 100%"
                      @change="selectRole(scope.row.name, scope.$index)"
                    >
                    </el-cascader>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-col>
        </div>
      </el-row>
      <div class="footer">
        <span slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            size="mini"
            @click="handleSubmit"
            v-preventReClick
            >确 定</el-button
          >
          <el-button size="mini" @click="cancel">取 消</el-button>
        </span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { importRole } from "@/api/roleModel";
import { getProjectId } from "@/utils/auth";

export default {
  name: "ImportRole",
  props: {
    importRoleVisible: {
      type: Boolean,
    },
    importRoleList: {
      type: Array,
    },
    authorityData: {
      type: Array,
    },
  },
  data() {
    return {
      value: [1],
      roleValue: [],
      selectVal: "",
      proId: "",
      tableData: [],
      showHeader: false, // 是否显示表头
      searchValue: "", // 搜索值
      leftTableData: [], // 左边表格数据
      rightTableData: [], // 右边表格数据
      nowSelectData: [], // 左边选中列表数据
      nowSelectRightData: [], // 右边选中列表数据
      selectDataList: [], // 下拉框选中的值
      roleData: [],
      importRoleActive: false,
      reqObj: {},
      props: {
        multiple: true,
        label: "label",
        value: "value",
        children: "children",
      },
    };
  },
  watch: {
    importRoleList: function () {
      this.leftTableData = JSON.parse(JSON.stringify(this.importRoleList));
    },
    authorityData: function () {
      this.roleData = this.authorityData;
    },
    importRoleVisible: function (newVal) {
      this.importRoleActive = newVal;
    },
  },
  created() {
    this.proId = getProjectId();
  },
  methods: {
    selectRole(res, index) {
      const fn = list => {
        return list.reduce((acc, item) => {
          !acc[item[0]]
            ? (acc[item[0]] = [item[1]])
            : acc[item[0]].push(item[1]);

          return acc;
        }, {});
      };
      this.rightTableData[index].authority = fn(this.selectDataList[res]);
    },
    // this.authorityData = res.data.map(item => {
    //   console.log(item.children)
    //   return item.children
    //   console.info(3123123)
    //   // this.authorityData = res.data
    //   let arr = []
    //   res.data.map(item => {
    //     console.info(123123)
    //     arr = [...arr, ...item.children]
    //   })
    // selectRole(name) {
    //   console.log(name)
    //   this.rightTableData.map(item => {
    //     console.log(item)
    //     if (item.name === name) {
    //       const obj = {}
    //       this.roleData.map(item => {
    //         console.log(item)
    //         this.selectDataList[name].map(auth => {
    //           console.log(555)
    //           console.log(auth)
    //           const filterArray = item.value.filter(val => val === auth)
    //           if (filterArray && filterArray.length > 0) {
    //             if (obj[item.name] && obj[item.name].length > 0) {
    //               obj[item.name].push(filterArray[0])
    //             } else {
    //               obj[item.name] = filterArray
    //             }
    //           }
    //         })
    //       })
    //       this.reqObj = obj
    //       item.authoritys = this.reqObj
    //     }
    //   })
    // },
    validate() {
      if (!this.rightTableData || this.rightTableData.length === 0) {
        this.$message({
          type: "warning",
          message: "请选择角色!",
        });
        return false;
      }
      const booleanRoles = this.rightTableData.some(
        (item) =>
          item.authority === null ||
          item.authority === "" ||
          item.authority === undefined
      );
      if (booleanRoles) {
        this.$message({
          type: "warning",
          message: "请选择权限!",
        });
        return false;
      }
      return true;
    },

    handleSubmit() {
      console.log("kankan");
      console.log(this.rightTableData);
      if (this.validate()) {
        const a = this.rightTableData.map((item) => {
          console.log(item);
          const obj = {};
          obj.name = item.name;
          obj.code = item.code;
          obj.is_doctor = item.is_doctor;
          obj.authority = item.authority;
          return obj;
        });
        const params = {
          role_list: a,
          project_id: this.proId,
        };
        importRole(params)
          .then((res) => {
            if (res && res.code === 0) {
              this.cancel();
              this.$message({
                message: res.msg,
                type: "success",
              });
            } else {
              this.$message(res.msg);
            }
          })
          .catch((res) => {
            console.log(res.msg);
          });
      }
    },
    cancel() {
      this.nowSelectData = [];
      this.rightTableData = [];
      this.selectDataList = [];
      this.importRoleActive = false;
      this.$parent.getRole();
    },
    close() {
      this.importRoleActive = false;
      this.cancel();
      this.$emit("childClose");
    },
    checkAll(val) {
      this.nowSelectData = val;
    },
    checkRightAll(val) {
      console.log("ncs");
      console.log(val);
      this.nowSelectRightData = val;
    },
    // 移除
    handelSelect() {
      this.rightTableData = this.handleConcatArr(
        this.rightTableData,
        this.nowSelectData
      );
      // console.log(this.rightTableData)
      this.handleRemoveTabList(this.nowSelectData, this.leftTableData);
      this.nowSelectData = [];
    },
    // 添加
    handleRemoveSelect() {
      this.leftTableData = this.handleConcatArr(
        this.leftTableData,
        this.nowSelectRightData
      );
      this.handleRemoveTabList(this.nowSelectRightData, this.rightTableData);
      this.nowSelectRightData = [];
    },
    handleConcatArr(a, b) {
      let arr = [];
      arr = arr.concat(a, b);
      return arr;
    },
    handleRemoveTabList(isNeedArr, originalArr) {
      if (isNeedArr.length && originalArr.length) {
        for (let i = 0; i < isNeedArr.length; i++) {
          for (let k = 0; k < originalArr.length; k++) {
            if (isNeedArr[i] === originalArr[k]) {
              originalArr.splice(k, 1);
            }
          }
          isNeedArr.map((item) => {
            const arr = [];
            item.children.map((a) => {
              a.children.map((b) => {
                const charr = [];
                charr.push(a.label);
                charr.push(b.label);
                arr.push(charr);
              });
            });
            this.selectDataList[item.name] = arr;
          });
        }
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      // 改表头颜色
      if (rowIndex === 0) {
        return "background-color: #D6E4FF;color: #666;";
      }
    },
  },
};
</script>

<style lang="scss">
.box {
  .tableBox {
    width: 100%;
    height: 300px;
    overflow-y: scroll;
  }
}
.dialogBox {
  .footer {
    text-align: center;
    margin-top: 40px;
  }
  .leftTable {
    background-color: #f0f5ff;
    padding: 5px;
    min-height: 300px;
    .leftTitle {
      text-align: center;
      font-size: 12px;
      color: #595959;
      font-weight: bold;
      background-color: #d6e4ff;
      padding: 10px 0;
    }
  }
  .btnMove {
    margin-top: 10%;
    text-align: center;
    .opSetting {
      margin: 10px 0;
    }
  }
  .transferBox {
    min-height: 300px;
    .el-transfer {
      .el-transfer-panel {
        width: 358px !important;
      }
    }
  }
}
</style>

<style>
.dialogBox {
  margin-top: 10px;
}
</style>
